import { lazyInit } from "./utilities-DtVOIXIY.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import "./mobile-anim-gate-Btn1wVuD.js";
class ContentExpand extends HTMLElement {
  constructor() {
    super();
    this.isExpanded = false;
    this.maxLines = this.getAttribute("data-max-lines") || 3;
    this._initialized = false;
  }
  connectedCallback() {
    const content = this.querySelector(".content-body-main");
    const buttonMore = this.querySelector(".button-show-more");
    const buttonLess = this.querySelector(".button-show-less");
    if (!content || !buttonMore || !buttonLess) return;
    this.content = content;
    this.buttonMore = buttonMore;
    this.buttonLess = buttonLess;
    lazyInit(this, () => {
      this.init();
      this._setupResizeObserver();
    });
  }
  isInteractionReady() {
    return this._initialized;
  }
  prepareInteraction() {
    if (!this._initialized) this.init();
    this._setupResizeObserver();
    return this.isConnected && this.isInteractionReady();
  }
  _setupResizeObserver() {
    if (this._ro) return;
    this._ro = new ResizeObserver(() => {
      if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(() => this.init(), 150);
    });
    this._ro.observe(this);
  }
  disconnectedCallback() {
    var _a;
    (_a = this._ro) == null ? void 0 : _a.disconnect();
    this._ro = null;
    if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
  }
  _handleResize() {
    if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => {
      requestAnimationFrame(() => this.init());
    }, 100);
  }
  init() {
    if (!this.content) return;
    if (this.isExpanded) return;
    const tolerance = 2;
    const isTruncated = this.content.scrollHeight > this.content.clientHeight + tolerance;
    if (isTruncated) {
      this.buttonMore.classList.remove("hidden");
      this.buttonLess.classList.add("hidden");
      if (!this.handlersBound) {
        this.buttonMore.addEventListener("click", () => this.showMore());
        this.buttonLess.addEventListener("click", () => this.showLess());
        this.content.addEventListener("focusin", () => {
          if (!this.isExpanded && !this.buttonMore.classList.contains("hidden")) {
            this.content.scrollTop = 0;
            this.showMore();
          }
        });
        this.handlersBound = true;
      }
    } else {
      this.buttonMore.classList.add("hidden");
      this.buttonLess.classList.add("hidden");
    }
    this._initialized = true;
  }
  showMore() {
    const startHeight = this.content.offsetHeight;
    const currentHostHeight = this.offsetHeight;
    this.style.height = `${currentHostHeight}px`;
    this.content.classList.add("expanded");
    const targetHeight = this.content.scrollHeight;
    this.content.style.height = `${startHeight}px`;
    this.content.style.overflow = "hidden";
    this.style.height = "";
    this.buttonMore.classList.add("hidden");
    this.buttonLess.classList.remove("hidden");
    this.isExpanded = true;
    requestAnimationFrame(() => {
      const anim = this.content.animate(
        { height: [`${startHeight}px`, `${targetHeight}px`] },
        { duration: 250, easing: "ease", fill: "forwards" }
      );
      anim.finished.then(() => {
        anim.cancel();
        this.content.style.height = "auto";
        this.content.style.overflow = "visible";
      }).catch(() => {
      });
    });
  }
  showLess() {
    const startHeight = this.content.offsetHeight;
    const currentHostHeight = this.offsetHeight;
    this.style.height = `${currentHostHeight}px`;
    this.content.classList.remove("expanded");
    this.content.style.height = "";
    const targetHeight = this.content.offsetHeight;
    this.content.classList.add("expanded");
    this.content.style.height = `${startHeight}px`;
    this.content.style.overflow = "hidden";
    this.style.height = "";
    this.buttonMore.classList.remove("hidden");
    this.buttonLess.classList.add("hidden");
    this.isExpanded = false;
    requestAnimationFrame(() => {
      const anim = this.content.animate(
        { height: [`${startHeight}px`, `${targetHeight}px`] },
        { duration: 250, easing: "ease", fill: "forwards" }
      );
      anim.finished.then(() => {
        anim.cancel();
        this.content.style.height = "";
        this.content.classList.remove("expanded");
        this.content.style.overflow = "";
      }).catch(() => {
      });
    });
  }
  collapse({ animate = true } = {}) {
    var _a, _b;
    if (!this.isExpanded || !this.content) return;
    if (animate) {
      this.showLess();
      return;
    }
    this.content.getAnimations().forEach((animation) => animation.cancel());
    this.style.height = "";
    this.content.classList.remove("expanded");
    this.content.style.height = "";
    this.content.style.overflow = "";
    (_a = this.buttonMore) == null ? void 0 : _a.classList.remove("hidden");
    (_b = this.buttonLess) == null ? void 0 : _b.classList.add("hidden");
    this.isExpanded = false;
  }
}
if (!customElements.get("content-expand")) {
  customElements.define("content-expand", ContentExpand);
}
